import React from "react";
import "./Careers.scss";

import CareerHero from "./CareerHero";
import WhyJoinUs from "./WhyJoinUs";
import Benefits from "./Benefits";
import OpenPositions from "./OpenPositions";
// import HiringProcess from "./HiringProcess";
import CareersCTA from "./CareersCTA";
import CareersFooter from "./CareersFooter";
// import Navbar from "../Navbar/Navbar";
import ProductNavbar from "../Navbar/ProductNavbar";

import { careersContent } from "./careersData";

const Careers = () => {
  return (
    <main className="careers" id="careers">
      <ProductNavbar />
      <CareerHero content={careersContent.hero} />

      <WhyJoinUs content={careersContent.whyJoinUs} />

      <Benefits benefits={careersContent.benefits} />

      <OpenPositions jobs={careersContent.jobs} />

      {/* <HiringProcess steps={careersContent.hiringProcess} /> */}

      <CareersCTA content={careersContent.cta} />

      <CareersFooter />
    </main>
  );
};

export default Careers;
